import React, { useState, useEffect } from 'react';
import axios from 'axios';
import config from '../config/config';
import { decodeToken, isExpired } from "react-jwt";
import Header from '../others/Header';

const SettingsPage = ({ user }) => {
    const [loading, setLoading] = useState(false);
    const [loadingLinks, setLoadingLinks] = useState(false);
    const { API_BASE_URL } = config;
    const [message, setMessage] = useState({ text: '', type: '' });
    const [backupOptions, setBackupOptions] = useState({
        format: 'sql',
        includeMedia: false,
        backupName: `backup_${new Date().toISOString().split('T')[0]}`
    });

    // Estados para links úteis
    const [usefulLinks, setUsefulLinks] = useState([]);
    const [newLink, setNewLink] = useState({
        title: '',
        url: '',
        color: '#3498db'
    });
    const [userData, setUserData] = useState(null);

    useEffect(() => {
        const token = localStorage.getItem("jwtToken");
        if (token === null || typeof token === "undefined" || isExpired(token)) {
            window.location.href = "/login";
        } else {
            const decoded = decodeToken(token);
            setUserData(decoded);
            console.log('TESTEEEE ', decoded)
        }
    }, []);


    // Carregar links ao montar o componente
    useEffect(() => {
        loadUsefulLinks();
    }, []);

    const loadUsefulLinks = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/links`, getAuthHeader());
            setUsefulLinks(response.data);
        } catch (error) {
            console.error('Erro ao carregar links:', error);
        }
    };

    const handleLinkInputChange = (e) => {
        const { name, value } = e.target;
        setNewLink(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleAddLink = async () => {
        if (!newLink.title.trim() || !newLink.url.trim()) {
            setMessage({ text: 'Preencha todos os campos', type: 'error' });
            return;
        }

        setLoadingLinks(true);
        try {
            // Garantir que a cor tenha o formato correto
            const linkData = {
                ...newLink,
                color: newLink.color.startsWith('#') ? newLink.color : `#${newLink.color}`
            };

            const response = await axios.post(`${API_BASE_URL}/links`, linkData, getAuthHeader());
            setUsefulLinks(prev => [...prev, response.data]);
            setNewLink({ title: '', url: '', color: '#3498db' }); // Reset para cor padrão
            setMessage({ text: 'Link adicionado com sucesso!', type: 'success' });
        } catch (error) {
            console.error('Erro ao adicionar link:', error);
            setMessage({ text: 'Erro ao adicionar link', type: 'error' });
        } finally {
            setLoadingLinks(false);
        }
    };

    const handleDeleteLink = async (linkId) => {
        try {
            await axios.delete(`${API_BASE_URL}/links/${linkId}`, getAuthHeader());
            setUsefulLinks(prev => prev.filter(link => link.id !== linkId));
            setMessage({ text: 'Link removido com sucesso!', type: 'success' });
        } catch (error) {
            console.error('Erro ao remover link:', error);
            setMessage({ text: 'Erro ao remover link', type: 'error' });
        }
    };

    const getAuthHeader = () => {
        const token = localStorage.getItem('jwtToken');
        return {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        };
    };

    const handleDownloadBackup = async () => {
        setLoading(true);
        setMessage({ text: '', type: '' });

        try {
            const response = await axios.get(`${API_BASE_URL}/backup/download`, {
                responseType: 'blob',
                headers: getAuthHeader().headers
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'backup.zip');
            document.body.appendChild(link);
            link.click();
            link.remove();

        } catch (error) {
            console.error('Erro ao baixar backup:', error);
            const errorMsg = error.response?.data?.message || 'Erro ao baixar backup. Por favor, tente novamente.';
            setMessage({ text: errorMsg, type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setBackupOptions(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    return (
        <div>
            <Header />
            <div style={styles.container}>
                <div style={styles.header}>
                    <h2 style={styles.title}>Configurações do Sistema</h2>
                    <p style={styles.subtitle}>Gerencie as configurações e preferências do sistema</p>
                </div>
                {(userData?.tipoUsuario === 'MANAGER' || userData?.possuiServerLocal === true) ? (
                    <div style={styles.card}>
                        <h3 style={styles.cardTitle}>Backup de Dados</h3>
                        <p style={styles.cardDescription}>
                            Gere e faça download de backups completos do banco de dados.
                        </p>

                        <div style={styles.formGroup}>
                            <label style={styles.label}>
                                Nome do Backup:
                                <input
                                    type="text"
                                    name="backupName"
                                    value={backupOptions.backupName}
                                    onChange={handleInputChange}
                                    style={styles.input}
                                    placeholder="Digite um nome para o backup"
                                />
                            </label>
                        </div>

                        {message.text && (
                            <div style={{
                                ...styles.alert,
                                ...(message.type === 'error' ? styles.alertError : styles.alertSuccess)
                            }}>
                                {message.text}
                            </div>
                        )}

                        <button
                            onClick={handleDownloadBackup}
                            disabled={loading}
                            style={loading ? { ...styles.button, ...styles.buttonLoading } : styles.button}
                        >
                            {loading ? (
                                <>
                                    <span style={styles.spinner}></span>
                                    Gerando Backup...
                                </>
                            ) : (
                                'Gerar Backup'
                            )}
                        </button>
                    </div>
                ) : ''}
                {/* Card de Links Úteis - VERSÃO CORRIGIDA */}
                <div style={styles.card}>
                    <h3 style={styles.cardTitle}>Links Úteis do Dashboard</h3>
                    <p style={styles.cardDescription}>
                        Adicione links rápidos que serão exibidos no dashboard para acesso rápido.
                    </p>

                    {/* Preview do card com a cor selecionada */}
                    <div style={styles.previewSection}>
                        <h4 style={styles.previewTitle}>Preview do Card:</h4>
                        <div
                            style={{
                                ...styles.cardPreview,
                                backgroundColor: newLink.color
                            }}
                        >
                            <div style={styles.previewContent}>
                                <span style={styles.previewText}>
                                    {newLink.title || "Seu link aparecerá aqui"}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div style={styles.formGroup}>
                        <label style={styles.label}>
                            Título do Link:
                            <input
                                type="text"
                                name="title"  // Corrigido: era "linkTitle"
                                value={newLink.title}
                                onChange={handleLinkInputChange}
                                style={styles.input}
                                placeholder="Ex: Documentação, Suporte, etc."
                            />
                        </label>
                    </div>

                    <div style={styles.formGroup}>
                        <label style={styles.label}>
                            URL:
                            <input
                                type="url"
                                name="url"  // Corrigido: era "linkUrl"
                                value={newLink.url}
                                onChange={handleLinkInputChange}
                                style={styles.input}
                                placeholder="https://exemplo.com"
                            />
                        </label>
                    </div>

                    <div style={styles.formGroup}>
                        <label style={styles.label}>
                            Cor do Botão:
                            <div style={styles.colorPickerContainer}>
                                <div
                                    style={{
                                        ...styles.colorPreview,
                                        backgroundColor: newLink.color
                                    }}
                                >
                                    <input
                                        type="color"
                                        name="color"  // Corrigido: era "linkColor"
                                        value={newLink.color}
                                        onChange={handleLinkInputChange}
                                        style={styles.colorInput}
                                        title="Selecione uma cor"
                                    />
                                </div>
                                <span style={styles.colorValue}>{newLink.color}</span>
                            </div>
                        </label>
                    </div>

                    <button
                        onClick={handleAddLink}
                        disabled={loadingLinks || !newLink.title.trim() || !newLink.url.trim()}
                        style={
                            loadingLinks || !newLink.title.trim() || !newLink.url.trim()
                                ? { ...styles.button, ...styles.buttonDisabled }
                                : styles.button
                        }
                    >
                        {loadingLinks ? 'Adicionando...' : 'Adicionar Link'}
                    </button>

                    {/* Lista de links existentes */}
                    {usefulLinks.length > 0 && (
                        <div style={styles.linksList}>
                            <h4 style={styles.linksTitle}>Links Cadastrados:</h4>
                            {usefulLinks.map((link, index) => (
                                <div key={index} style={styles.linkItem}>
                                    <div style={styles.linkPreview}>
                                        <div
                                            style={{
                                                ...styles.linkColorIndicator,
                                                backgroundColor: link.color
                                            }}
                                        />
                                    </div>
                                    <div style={styles.linkInfo}>
                                        <span style={styles.linkTitle}>{link.title}</span>
                                        <span style={styles.linkUrl}>{link.url}</span>
                                    </div>
                                    <div style={styles.linkActions}>
                                        <button
                                            onClick={() => handleDeleteLink(link.id)}
                                            style={styles.deleteButton}
                                        >
                                            Excluir
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

// Estilos atualizados e corrigidos
const styles = {
    container: {
        flex: 1,
        padding: '2rem',
        paddingLeft: '60px',
        backgroundColor: '#f5f7fa',
        minHeight: '100vh'
    },
    header: {
        marginBottom: '2rem',
    },
    title: {
        fontSize: '1.5rem',
        fontWeight: '600',
        color: '#2d3748',
        margin: '0 0 0.5rem 0',
    },
    subtitle: {
        fontSize: '0.875rem',
        color: '#718096',
        margin: '0',
    },
    card: {
        backgroundColor: '#ffffff',
        borderRadius: '0.5rem',
        padding: '1.5rem',
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
        marginBottom: '1.5rem',
    },
    cardTitle: {
        fontSize: '1.125rem',
        fontWeight: '600',
        color: '#2d3748',
        margin: '0 0 0.5rem 0',
    },
    cardDescription: {
        fontSize: '0.875rem',
        color: '#718096',
        margin: '0 0 1rem 0',
    },
    formGroup: {
        marginBottom: '1rem',
    },
    label: {
        display: 'block',
        marginBottom: '0.5rem',
        fontSize: '0.875rem',
        fontWeight: '500',
        color: '#4a5568',
    },
    input: {
        width: '100%',
        padding: '0.5rem 0.75rem',
        fontSize: '0.875rem',
        border: '1px solid #e2e8f0',
        borderRadius: '0.375rem',
        backgroundColor: '#fff',
        transition: 'border-color 0.2s',
        outline: 'none',
        boxSizing: 'border-box',
    },
    button: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0.5rem 1rem',
        backgroundColor: '#4299e1',
        color: '#fff',
        fontSize: '0.875rem',
        fontWeight: '500',
        borderRadius: '0.375rem',
        border: 'none',
        cursor: 'pointer',
        transition: 'background-color 0.2s',
        outline: 'none',
    },
    buttonLoading: {
        backgroundColor: '#bee3f8',
        cursor: 'not-allowed',
    },
    buttonDisabled: {
        backgroundColor: '#a0aec0',
        cursor: 'not-allowed',
    },
    spinner: {
        display: 'inline-block',
        width: '1rem',
        height: '1rem',
        border: '2px solid rgba(255, 255, 255, 0.3)',
        borderRadius: '50%',
        borderTopColor: '#fff',
        animation: 'spin 1s linear infinite',
        marginRight: '0.5rem',
    },
    alert: {
        padding: '0.75rem 1rem',
        borderRadius: '0.375rem',
        marginBottom: '1rem',
        fontSize: '0.875rem',
    },
    alertSuccess: {
        backgroundColor: '#f0fff4',
        color: '#2f855a',
        border: '1px solid #c6f6d5',
    },
    alertError: {
        backgroundColor: '#fff5f5',
        color: '#c53030',
        border: '1px solid #fed7d7',
    },

    // Novos estilos para a seção de links úteis
    previewSection: {
        marginBottom: '1.5rem',
        padding: '1rem',
        backgroundColor: '#f8f9fa',
        borderRadius: '0.375rem',
        border: '1px solid #e2e8f0',
    },
    previewTitle: {
        fontSize: '0.875rem',
        fontWeight: '600',
        color: '#4a5568',
        margin: '0 0 0.5rem 0',
    },
    cardPreview: {
        padding: '1rem',
        borderRadius: '0.375rem',
        minHeight: '60px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'background-color 0.3s ease',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    },
    previewContent: {
        textAlign: 'center',
    },
    previewText: {
        color: 'white',
        fontWeight: '600',
        fontSize: '0.875rem',
        textShadow: '0 1px 2px rgba(0,0,0,0.3)',
    },
    colorPickerContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '1rem',
        marginTop: '0.5rem',
    },
    colorPreview: {
        width: '50px',
        height: '50px',
        borderRadius: '0.375rem',
        border: '2px solid #e2e8f0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        cursor: 'pointer',
    },
    colorInput: {
        width: '100%',
        height: '100%',
        border: 'none',
        background: 'transparent',
        cursor: 'pointer',
        opacity: 0,
    },
    colorValue: {
        fontSize: '0.875rem',
        color: '#4a5568',
        fontWeight: '500',
        fontFamily: 'monospace',
    },
    linksList: {
        marginTop: '1.5rem',
        borderTop: '1px solid #e2e8f0',
        paddingTop: '1rem',
    },
    linksTitle: {
        fontSize: '1rem',
        fontWeight: '600',
        color: '#2d3748',
        marginBottom: '1rem',
    },
    linkItem: {
        display: 'flex',
        alignItems: 'center',
        padding: '0.75rem',
        border: '1px solid #e2e8f0',
        borderRadius: '0.375rem',
        marginBottom: '0.5rem',
        backgroundColor: '#f8f9fa',
        gap: '1rem',
    },
    linkPreview: {
        flexShrink: 0,
    },
    linkColorIndicator: {
        width: '20px',
        height: '20px',
        borderRadius: '0.25rem',
        border: '1px solid #e2e8f0',
    },
    linkInfo: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
    },
    linkTitle: {
        fontWeight: '600',
        color: '#2d3748',
        marginBottom: '0.25rem',
    },
    linkUrl: {
        fontSize: '0.75rem',
        color: '#718096',
        wordBreak: 'break-all',
    },
    linkActions: {
        marginLeft: 'auto',
    },
    deleteButton: {
        padding: '0.25rem 0.75rem',
        backgroundColor: '#e53e3e',
        color: 'white',
        border: 'none',
        borderRadius: '0.25rem',
        fontSize: '0.75rem',
        cursor: 'pointer',
        transition: 'background-color 0.2s',
    },
};

// Adicione isso ao seu CSS global ou dentro do componente
const globalStyles = `
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
`;

export default SettingsPage;